import { request } from '@/api/apiUtils';
import type { EntityDefinition, FetcherEntry } from '@/data/types';
import type { IBit } from '@/types';

/** Root: query-key prefix for this entity's slice of the cache (ADR 0010) */
export const BITS_ROOT = ['bits'] as const;

interface BitsListParams {
    episodeId: number;
    version?: string;
}

const fetchers = {
    list: {
        key: ({ episodeId, version }: BitsListParams) =>
            [...BITS_ROOT, 'list', version !== undefined ? { episodeId, version } : { episodeId }] as const,
        fetch: async ({ episodeId, version }: BitsListParams): Promise<IBit[]> => {
            const params = new URLSearchParams();
            if (version) params.append('version', version);
            const endpoint = `episodes/${episodeId}/bits${params.toString() ? `?${params}` : ''}`;
            const data: { data: IBit[] } = await request(endpoint);
            return data.data;
        },
    },
    // biome-ignore lint/suspicious/noExplicitAny: required for generic type inference
} satisfies Record<string, FetcherEntry<any, any>>;

export const bitsEntity: EntityDefinition<typeof fetchers> = {
    name: 'bits',
    roots: [BITS_ROOT],
    fetchers,
};

export type { BitsListParams };
